import type { FC, TextareaHTMLAttributes } from "react";
import TextareaAutosize, { type TextareaAutosizeProps } from "react-textarea-autosize";
import { twMerge } from "tailwind-merge";

import { TEXT_FIELD_BASE_CLASSES } from "./TextField";

type TextAreaType = TextareaAutosizeProps & TextareaHTMLAttributes<HTMLTextAreaElement>;

interface TextAreaProps extends TextAreaType {
  size?: "s" | "m";
}

const COMMON_CLASSES = twMerge(
  TEXT_FIELD_BASE_CLASSES,
  "rounded-[10px] supports-squircle:rounded-[20px] resize-none",
);

const SIZE_CLASSES = {
  s: "body-s px-2.5 py-2",
  m: "body-m px-3 py-2.5",
};

export const TextArea: FC<TextAreaProps> = ({ size = "s", minRows = 5, className, ...props }) => {
  return (
    <TextareaAutosize
      className={twMerge(COMMON_CLASSES, SIZE_CLASSES[size], className)}
      minRows={minRows}
      {...props}
    />
  );
};
